import { styled } from "@mui/material/styles";

const StyledResetPassword = styled("div")`
  width: 100%;
  max-width: 500px;

  & > .reset-password__btn {
    margin: 32px 0 24px;
  }
`;

const StyledResetPasswordHeadings = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    max-width: 400px;
  }
`;

const StyledResetPasswordFields = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

export {
  StyledResetPassword,
  StyledResetPasswordHeadings,
  StyledResetPasswordFields,
};
